import common from '../common';

export default {
  jpath: ['spectra', 'ir'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
  process: common.getMetaFromJcamp,
};
